import React, { useEffect, useState } from 'react'
import { HeaderMenu } from '../../component/HeaderMenu'
import { FormControl, InputLabel, MenuItem, Pagination, Select, Stack } from '@mui/material'
import { AddLog } from '../../api/crudSolicitud/AddLog.api';


export const LogCambioStatus = () => {

  const [Orden, setOrden] = useState("DESC");//DESC || ASC
  const [OrdenTxt, setOrdenTxt] = useState("");//Item de tabla
  const [first, setFirst] = useState([]);

  function ordenarData(data, key, ord = 'ASC') {
    if (!Array.isArray(data)) throw new TypeError('data debe ser un array');
    const arr = [...data]; // clonar para no mutar el original
    const order = (ord || 'ASC').toUpperCase(); // normalizar

    const tryParseDate = (v) => {
      if (typeof v !== 'string') return null;
      const m = v.match(/^(\d{2})\/(\d{2})\/(\d{4}),?\s+(\d{2}):(\d{2}):(\d{2})$/);
      if (m) {
        const [, dd, mm, yyyy, HH, MM, SS] = m;
        const ts = Date.parse(`${yyyy}-${mm}-${dd}T${HH}:${MM}:${SS}Z`);
        return isNaN(ts) ? null : ts;
      }
      const ts = Date.parse(v);
      return isNaN(ts) ? null : ts;
    };

    const norm = (v) => {
      if (v == null) return { t: 'null', v: -Infinity };
      if (typeof v === 'number') return { t: 'num', v };
      if (typeof v === 'boolean') return { t: 'num', v: v ? 1 : 0 };
      if (typeof v === 'string') {
        const num = Number(v.replace(/,/g, ''));
        if (!isNaN(num) && v.trim() !== '') return { t: 'num', v: num };
        const d = tryParseDate(v);
        if (d != null) return { t: 'date', v: d };
        return { t: 'str', v: v.toLowerCase() };
      }
      return { t: 'str', v: JSON.stringify(v).toLowerCase() };
    };

    arr.sort((a, b) => {
      const A = norm(a[key]);
      const B = norm(b[key]);
      const typePriority = { num: 3, date: 3, str: 2, null: 1 };
      const tpA = typePriority[A.t] || 0;
      const tpB = typePriority[B.t] || 0;
      if (tpA !== tpB) return (tpB - tpA) * (order === 'ASC' ? -1 : 1);

      let cmp = 0;
      if (A.v < B.v) cmp = -1;
      else if (A.v > B.v) cmp = 1;

      if (order === 'DESC') cmp = -cmp;
      return cmp;
    });

    setOrdenTxt(key);//item para ordenar
    setOrden(order === 'ASC' ? 'DESC' : 'ASC');
    setFirst(arr);//resultado del array ordenado
    return arr;
  }

  /** tabla con paginacion */
  const [n_pp, setN_pp] = useState(50);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const getLogStatusChanges = async () => {
    // Aquí iría la lógica para obtener los logs de cambios de estado desde el backend
    let items = await AddLog({
      pagina: page,
      n_pp: n_pp,
      action: "READ",
    })
    // console.log("items:", items.body)
    setFirst(items.body.docs)
    setTotalPages(items.body.totalPages);
  }

  useEffect(() => {
    getLogStatusChanges();
    // setFirst(porNumero)
  }, [n_pp, page])

  
  return (<>
    <HeaderMenu Pag_Sel={'log_cambio_status'} />
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-12 pl-4 py-1'> 
          <h5 className=' lead '>Log de Cambios de Estado a Solicitudes</h5>
        </div>
      </div>
      </div>

      <div className='col-12'>

        {/* table header */}
        <div className='row py-2 mx-2' style={{backgroundColor: '#000000', color: "#ffffff", cursor: 'pointer'}}>
          <div className='text-center' style={{width:'3%'}}>
              <small>N°</small>
          </div>
          <div style={{width:'25%'}} onClick={()=>ordenarData(first, "user", Orden)}>
              <small>Usuario{OrdenTxt === "user" ? Orden === "ASC" ? " ↓" : " ↑" : null}</small>
          </div>
          <div style={{width:'12%'}} onClick={()=>ordenarData(first, "planta", Orden)}>
              <small>Planta{OrdenTxt === "planta" ? Orden === "ASC" ? " ↓" : " ↑" : null}</small>
          </div>
          <div style={{width:'10%'}} onClick={()=>ordenarData(first, "status_old", Orden)}>
              <small>Estatus Antiguo{OrdenTxt === "status_old" ? Orden === "ASC" ? " ↓" : " ↑" : null}</small>
          </div>
          <div style={{width:'10%'}} onClick={()=>ordenarData(first, "status_new", Orden)}>
              <small>Estatus Nuevo{OrdenTxt === "status_new" ? Orden === "ASC" ? " ↓" : " ↑" : null}</small>
          </div>
          <div style={{width:'20%'}} onClick={()=>ordenarData(first, "notes", Orden)}>
              <small>Nota{OrdenTxt === "notes" ? Orden === "ASC" ? " ↓" : " ↑" : null}</small>
          </div>
          <div className='text-center' style={{ width: '20%'}} onClick={()=>ordenarData(first, "timestamp", Orden)}>
              <small>Fecha{OrdenTxt === "timestamp" ? Orden === "ASC" ? " ↓" : " ↑" : null}</small>
          </div>
        </div>

        {/* table body */}
        <div className='col-12 mb-2 ml-1' style={{height: '65vh', overflowY: 'scroll', padding: '0px', margin: '0px'}}>
            {/* <div className='row' style={{width: '100%'}}> */}
                {
                    first.map((item, index) => (
                        <div key={index} className='row sobre-m' style={{width: '100%', marginLeft: "0px"}}>
                            <td
                              className='text-center'
                              style={{alignItems: 'center', justifyContent: 'center', alignContent: 'center', width: '3%', paddingLeft: '5px'}}>
                                <small><b>{page === 1?(index+1):(page-1)*n_pp+index+1}</b></small>
                            </td>
                            <td style={{alignItems: 'center', justifyContent: 'center', alignContent: 'center', width: '25%', paddingLeft: '5px'}}>
                                <small>{item?.["user"]}</small>
                            </td>
                            <td style={{alignItems: 'center', justifyContent: 'center', alignContent: 'center', width: '12%'}}>
                                <small>{item?.["planta"]}</small>
                            </td>
                            <td style={{alignItems: 'center', justifyContent: 'center', alignContent: 'center',width: '10%'}}>
                                <small>{item?.["status_old"]}</small>
                            </td>
                            <td style={{alignContent: 'center', width: '10%',  paddingLeft: '8px'}} className=''>
                                <small><b>{item["status_new"]}</b></small>
                            </td>
                            <td style={{alignItems: 'center', justifyContent: 'center', alignContent: 'center', width: '20%'}}>
                                <small>{item?.notes}</small>
                            </td>
                            <td style={{ alignContent: 'center', width: '20%'}} className='text-center'>
                                <small>{new Date(item?.["timestamp"]).toLocaleString()}</small>
                            </td>
                        </div>
                    ))
                }
            {/* </div> */}
        </div>

        {/* paginacion */}
        <div className='col-12'>
          <div className='row'>
            <div className='col-9'>
              <Stack spacing={1}>
                <Pagination
                  count={totalPages} color="secondary" shape="rounded" size='small'
                  showFirstButton showLastButton
                  onChange={(event, value)=>setPage(value)}/>
              </Stack>
            </div>
            <div className='col-3'>
              <FormControl fullWidth size='small'>
                <InputLabel id="demo-simple-select-label">Cantidad de datos</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Cantidad de datos"
                  value={n_pp}
                  onChange={(e) => setN_pp(e.target.value)}
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={75}>75</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>
        </div>

      </div>

  </>
  )
}
